import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { copyAllTaskPropertiesToTmp } from '../../../../redux/tasks/actions';

const EditTaskMenuItem = ({ handleClick, taskId }) => {
  const dispatch = useDispatch();

  const handleItemClick = () => {
    dispatch(copyAllTaskPropertiesToTmp(taskId));
    handleClick && handleClick(taskId);
  };
  return (
    <div onClick={handleItemClick}>
      <FormattedMessage id="EDIT" defaultMessage="Edit" />
    </div>
  );
};

export default EditTaskMenuItem;
